export default {
  webApi: {
    offlineToken: '/mobile-token/v1/generate-offline-token',
  },
  contentApi: {
    headerFooter: '/mobile-token-generator/mobile/v1/mocks/headerFooterContent.json?SYS=UB',
    mobileTokenGenerator: '/mobile-token-generator/mobile/v1/mocks/mobileTokenGenerator.json?SYS=UB',
    mobileTokenSuccess: '/mobile-token-generator/mobile/v1/mocks/mobileTokenSuccess.json?SYS=UB',
    mobileTokenFailure: '/mobile-token-generator/mobile/v1/mocks/mobileTokenFailure.json?SYS=UB',
  },
};
